// A Chamber Member Pro chamber sends Member Dashboard credentials from the
// Chamber Member Pro dashboard. The backend refuses the old bulk credential
// tools for those chambers (assertLegacyBulkCredentialToolsAvailable in
// cap-backend); the refusal pop-up then points staff there (Wasaga, Oct 2026).
export const CHAMBER_MEMBER_PRO_DASHBOARD_URL = "https://dashboard.chambermemberpro.com";

// First sentence of the backend refusal (CMP_LEGACY_BULK_CREDENTIALS_MESSAGE).
const CHAMBER_MEMBER_PRO_REFUSAL_START = "Your chamber now sends Member Dashboard credentials from Chamber Member Pro";

export const isChamberMemberProCredentialRefusal = (message?: string | null): boolean =>
  !!message && message.startsWith(CHAMBER_MEMBER_PRO_REFUSAL_START);
